import { z } from 'zod';
export const announcementSchema = z.object({
  body: z.string().trim().min(1, 'Your announcement must have a body'),
});
